import { render } from "./PlanejamentoCadView.vue?vue&type=template&id=5f80e2f2"
import script from "./PlanejamentoCadView.vue?vue&type=script&lang=js"
export * from "./PlanejamentoCadView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__